import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { updateAttractionActive } from '~/services/AttractionsService';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UpdateAttractionActiveData {
  attractionId: string;
  active: boolean;
}

/**
 * Toggles attraction active/inactive and invalidates the list cache.
 */
export function useUpdateAttractionActive() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ attractionId, active }: UpdateAttractionActiveData) => {
      return await updateAttractionActive(attractionId, active);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.all });
      enqueueSnackbar(`Attraction ${variables.active ? 'activated' : 'deactivated'} successfully`, {
        variant: 'success',
      });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error updating attraction: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
